/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Component, TemplateRef, ViewChild} from '@angular/core';
export class TemplateRefContainer {  template: TemplateRef<any>; static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    template: `
      <ng-template>
        <ng-content></ng-content>
      </ng-template>
    `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'template': [{ type: ViewChild, args: [TemplateRef, ] },],
};
}

function TemplateRefContainer_tsickle_Closure_declarations() {
/** @type {?} */
TemplateRefContainer.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TemplateRefContainer.ctorParameters;
/** @type {?} */
TemplateRefContainer.propDecorators;
/** @type {?} */
TemplateRefContainer.prototype.template;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
